<template>
    <div class="page">
        <v-toolbar color="blue" dark>
            <v-toolbar-items>
                <v-btn flat>Фильмы</v-btn>
                <v-btn flat>Сериалы</v-btn>
                <v-btn flat>Мультфильмы</v-btn>
                <v-btn flat>Новости</v-btn>
            </v-toolbar-items>

            <v-spacer></v-spacer>

            <v-toolbar-items>
                <v-btn flat>Вход</v-btn>
                <v-btn flat @click="onOpenReg">Регистрация</v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-carousel>
            <v-carousel-item
                    v-for="(item, i) in items"
                    :key="i"
                    :src="item">
            </v-carousel-item>
        </v-carousel>

        <div class="page-body">
            <h2>Смотрите лучшие фильмы онлайн бесплатно</h2>

            <v-layout wrap>
                <v-flex xs12 sm3 v-for="(film, index) in films" :key="index">
                    <div class="pt-2 pl-2 pr-2">
                        <v-card>
                            <v-card-media :src="film.image" height="300px"></v-card-media>
                            <v-card-title primary-title>
                                <div>
                                    <h3 class="headline mb-0">{{film.name}}</h3>
                                    <span>{{film.desc}}</span>
                                </div>
                            </v-card-title>
                        </v-card>
                    </div>
                </v-flex>
            </v-layout>
        </div>

        <Reg ref="reg" @success="onSuccessReg"/>

        <v-dialog v-model="regSuccess" width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>Регистрация завершена</v-card-title>
                <v-card-text>Вы успешно зарегистрировались в онлайн кинотеатре</v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="regSuccess = false">Закрыть</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import data from './data'
    import Reg from './reg-pay'
    import shuffle from 'shuffle-array'
    import mixin from '@/web/mixin.js'

    export default {
        mixins: [mixin],
        components: {
            Reg
        },
        data () {
            return {
                items: shuffle(data.slides).slice(0, 3),
                films: shuffle(data.films).slice(0, 16),
                regSuccess: false
            }
        },
        methods: {
            onOpenReg () {
                this.$refs.reg.open()
            },
            onSuccessReg () {
                this.regSuccess = true
                this.event('registered', {
                    site: 'online-cinema-pay'
                })
            }
        },
        mounted () {
            this.event('view', {site: 'online-cinema-pay'})
        }
    }
</script>
<style lang="stylus" scoped>
    .page {
        height 100%
        background-color #3366bb
    }
    .page-body {
        max-width 1300px
        padding 0 25px
        margin 20px auto
    }
</style>